import { TOOLBOX_TEXT } from "@/lib/toolbox/type-scale";

/**
 * Class names the Project page's tabs share (PKG-PM-F, feature
 * PI-SPEC-SW-1510): moved unchanged out of the old Repos page so the
 * Repositories and Product areas tabs keep the same look.
 */

/** A primary action button (design `.btnp`). */
export const PROJECT_PRIMARY_BUTTON = "border-primary bg-primary font-semibold text-primary-foreground hover:bg-primary/90";

/** A table header row (design `.thd`). */
export const PROJECT_TABLE_HEAD = `border-b border-border px-[18px] py-2 text-[11px] font-semibold uppercase tracking-[0.06em] ${TOOLBOX_TEXT.faint}`;

/** A quiet row action (design `.btng`). */
export const PROJECT_GHOST_ACTION =
  "inline-flex h-[30px] items-center rounded-lg px-2.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-[#141417] hover:text-foreground disabled:pointer-events-none disabled:opacity-40";
